"use strict";

const { Swiper } = await import("../swiper/swiper.js"),
	{ Autoplay } = await import("../swiper/autoplay.js"),
	{ EffectFade } = await import("../swiper/effect-fade.js");

new Swiper(".swiper-hero", {
	autoplay: {
		delay: 3000,
		disableOnInteraction: false,
	},
	effect: "fade",
	fadeEffect: {
		crossFade: true,
	},
	loop: true,
	modules: [Autoplay, EffectFade],
	speed: 1000,
	watchOverflow: true,
	watchSlidesProgress: true,
});
